import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(0, {

    [actions.LOAD_LIGHT_STOMPUNKTER_REQUEST]: (state, action) => state + 1,

    [actions.LOAD_LIGHT_STOMPUNKTER_ERROR]: (state, action) => state - 1,

    [actions.LOAD_LIGHT_STOMPUNKTER_SUCCESS]: (state, action) => state - 1

})


// WEBPACK FOOTER //
// ./src/reducers/pendingRequestCount.js